import { useState, useEffect } from 'react';
import moment from 'moment';

import { getFirestore, doc, collection, getDocs, getDoc, updateDoc, query, where } from 'firebase/firestore';
import app from '../firebase';

export default function Customers() {

    const [order, setOrder] = useState();
    const [orderStatus, setOrderStatus] = useState('ordered');

    const [customers, setCustomers] = useState();

    const getOrders = async () => {
        let x = [];

        await getDocs(query(collection(getFirestore(app), 'orders'), where('seller.id', '==', localStorage.getItem('userId'))))
            .then(results => {
                results.forEach(i => i.data().status === orderStatus && x.push([i.id, i.data()]))
            });

        setCustomers(x);
    }

    const acceptOrder = orderId => {
        updateDoc(doc(getFirestore(app), 'orders', orderId), { status: 'accepted' });
        alert('You have successfully accepted the order');
    }

    const declineOrder = orderId => {
        updateDoc(doc(getFirestore(app), 'orders', orderId), { status: 'declined' });
        alert('You have successfully declined the order');
    }

    useEffect(() => {
        getOrders();
    }, [orderStatus, acceptOrder, declineOrder]);

    return(
        <>
            <div className="container-fluid bg-light p-4">
                <h1>My Customers</h1>

                <select className="form-select mb-2" onChange={data => setOrderStatus(data.target.value)}>
                    <option value="ordered" selected>Ordered</option>
                    <option value="accepted">Accepted</option>
                    <option value="declined">Declined</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="shipped">Shipped</option>
                    <option value="received">Received</option>
                </select>

                <table className="table table-sm table-borderless text-center">
                    <thead>
                        <tr>
                            <th scope="col">Customer</th>
                            <th scope="col">Date Ordered</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            customers && customers.map(i => (
                                <tr>
                                    <td>{i[1].customer.name}</td>
                                    <td>{moment(i[1].date.toDate()).format('LL')}</td>
                                    <td>{i[1].status}</td>
                                    <td>
                                        <button className="btn btn-sm btn-outline-dark me-1"><i className="bi-chat me-1"></i>Message</button>
                                        <button className="btn btn-sm btn-dark me-1" data-bs-toggle="modal" data-bs-target="#orderItems"><i className="bi-eye me-1"></i>View</button>
                                        <button className="btn btn-sm btn-success me-1" onClick={() => acceptOrder(i[0])}><i className="bi-check-lg me-1"></i>Accept</button>
                                        <button className="btn btn-sm btn-danger me-1" onClick={() => declineOrder(i[0])}><i className="bi-x-lg me-1"></i>Decline</button>
                                        <button className="btn btn-sm btn-dark" onClick={() => acceptOrder(i[0])}><i className="bi-check-lg me-1"></i>Shipped</button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>

            {/* MODALS */}
            <div className="modal fade" id="orderItems" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Modal title</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            ...
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary">Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}